export default "__VITE_ASSET__1a40253c__"